import { Image } from "@mantine/core";

export default function Logo({ h = 32, radius = "xl" }) {
	return <Image src="/img/economos_logo.png" h={h} w={h} radius={radius} />;
}
